module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_koryucenter-ca65759cd7d10436d0e200c6432492a6.jpg";